module.exports = __webpack_public_path__ + "img/备注.22b5080a.png";